import { computed, unref } from 'vue'
import { i18n } from '@/locales/setupI18n'
import dayjs from 'dayjs'
import { LocaleType } from '@/settings/locale'
import { importLocaleData, setHTMLElemLang, loadedLocale } from '@/locales/helper'
import { useLocaleStoreWithOut } from '@/store-pinia/modules/locale'
import { notifyLocaleChange } from '@/locales/localeChange'

export const setI18nLocale = (locale: LocaleType) => {
  const store = useLocaleStoreWithOut()
  ;(i18n.global.locale as any).value = locale
  store.setLocaleInfo({ locale })
  setHTMLElemLang(locale)
  loadedLocale.push(locale)
  notifyLocaleChange(locale)
}

export const swtichLocale = (locale: LocaleType) => {
  const store = useLocaleStoreWithOut()
  store.setLocaleInfo({ locale, originalLocale: locale })
  window.location.reload()
}

export function useLocale() {
  const store = useLocaleStoreWithOut()
  const locale = computed(() => store.getLocale)
  const originalLocale = computed(() => store.getOriginalLocale)

  const antLocale = computed(
    // @ts-ignore
    (): any => i18n.global.getLocaleMessage(unref(locale))?.antLocale ?? {},
  )

  const getLocaleMessage = computed(() => i18n.global.getLocaleMessage(unref(locale)))

  const changeLocale = async (locale: LocaleType) => {
    const i18nGlobal = i18n.global
    const curLocale = unref(i18nGlobal.locale)
    if (locale === curLocale) {
      return
    }
    if (loadedLocale.includes(locale)) {
      return setI18nLocale(locale)
    }
    store.setLocaleInfo({ locale })
    const localeData = await importLocaleData(locale)
    const localeModule = localeData?.default
    if (!localeModule) {
      return
    }

    const { message, dayjsLocale, dayjsLocaleName } = localeModule
    i18nGlobal.setLocaleMessage(locale, message)
    dayjs.locale(dayjsLocaleName, dayjsLocale)
    setI18nLocale(locale)
    return locale
  }

  return {
    locale,
    originalLocale,
    antLocale,
    getLocaleMessage,
    changeLocale,
  }
}
